import React, { useState } from 'react'
import { version } from '../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { italyFlag, englishFlag } from '../../assets'
import { Select } from 'antd'
import { setLanguage } from '../../Redux/actions/languageAction'
import MobileMenu from '../SideMenu/MobileMenu'
import { Menu } from 'lucide-react'
import { elmecLogo } from '../../assets'

const Header = ({ setCollapsed }) => {
    const dispatch = useDispatch()
    const language = useSelector((state) => state.languageReducer?.language)
    const organizationDetails = useSelector(state => state?.authReducer?.organization)
    // console.log('organizationDetails', organizationDetails)
    const [isMenuOpen, setIsMenuOpen] = useState(false)


    const handleLanguageChange = (value) => {
        dispatch(setLanguage(value))
    }

    const toggleMobileMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    return (
        <div className='header-main-div'>
            <div className='header-inner-div'>
                <div className='header-menu-icon mobile-menu-icon mobile-menu-main-div' onClick={toggleMobileMenu}>
                    <Menu size={24} />
                </div>
                <div className='web-menu-div'>
                    <div style={{ cursor: 'pointer' }} onClick={() => setCollapsed(prev => !prev)}>
                        <Menu size={24} />
                    </div>
                    <div>
                        <div className='logo-container'>
                            <div className='logo-main-div'>
                                <img src={organizationDetails?.logo || elmecLogo} alt='Default Logo' className='sidelogo' />
                                {/* <p className='org-name'>{organizationDetails?.name || ''}</p> */}
                            </div>
                        </div>

                    </div>
                </div>
                <div className='header-inner2-div'>
                    <div className='header-icons'>
                        <span className="version_txt">v{version}</span>
                        <div className="header-language-div">
                            <Select
                                value={language}
                                style={{
                                    width: 30,
                                    marginRight: '11px',
                                }}
                                onChange={handleLanguageChange}
                                suffixIcon={null}
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{
                                    minWidth: 5,
                                    padding: 0
                                }}
                                className="flag-select"
                            >
                                <Option value="it">
                                    <img
                                        src={italyFlag}
                                        alt="Italian"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </Option>
                                <Option value="en">
                                    <img
                                        src={englishFlag}
                                        alt="English"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </Option>
                            </Select>
                        </div>
                    </div>
                </div>
            </div>

            <div className='mobile-menu-main-div'>
                <MobileMenu isOpen={isMenuOpen} onClose={toggleMobileMenu} />
            </div>
        </div>
    )
}

export default Header
